var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferralProgram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2684",
    "data-name": "Group 2684",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 19.862,
    viewBox: "0 0 22 19.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1448",
    "data-name": "Rectangle 1448",
    width: 22,
    height: 19.862,
    transform: "translate(0 0)",
    fill: "#22c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2684-2",
    "data-name": "Group 2684",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8236",
    "data-name": "Path 8236",
    d: "M286.275,21.891a3.347,3.347,0,0,1-.331,1.456,3.4,3.4,0,0,1-.186.332,3.353,3.353,0,0,1-5.731-.1,3.059,3.059,0,0,1-.172-.334,3.341,3.341,0,0,1-.286-1.358c0-.075,0-.149.008-.224a3.063,3.063,0,0,1,.046-.379,3.354,3.354,0,0,1,6.6.02,3.127,3.127,0,0,1,.044.382c0,.066.006.133.006.2",
    transform: "translate(-277.261 -18.385)",
    fill: "#22c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8237",
    "data-name": "Path 8237",
    d: "M949.888,1203.613h0a7.11,7.11,0,0,0-7.11,7.11v1.7H957v-1.7a7.11,7.11,0,0,0-7.11-7.11",
    transform: "translate(-934.997 -1193.68)",
    fill: "#22c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8238",
    "data-name": "Path 8238",
    d: "M1298.119,0a4.213,4.213,0,0,0-4.144,3.455,3.86,3.86,0,0,0-.058.475c-.007.093-.01.187-.01.281a4.2,4.2,0,0,0,.359,1.705,3.845,3.845,0,0,0,.216.42,4.211,4.211,0,0,0,7.2.122,4.263,4.263,0,0,0,.233-.417,4.2,4.2,0,0,0,.416-1.829c0-.084,0-.168-.008-.251a3.933,3.933,0,0,0-.056-.48A4.212,4.212,0,0,0,1298.119,0",
    transform: "translate(-1283.229 0)",
    fill: "#22c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8239",
    "data-name": "Path 8239",
    d: "M5.661,990.405h0A5.661,5.661,0,0,0,0,996.066v.577l2.514-3.291a1.373,1.373,0,0,1,2.181,0l2.253,2.95a8.521,8.521,0,0,1,3.006-3.919,5.644,5.644,0,0,0-4.293-1.978",
    transform: "translate(0 -982.231)",
    fill: "#22c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8240",
    "data-name": "Path 8240",
    d: "M101.221,1452.429c.043.167.108.329.163.49s.132.317.2.472a5.536,5.536,0,0,0,1.155,1.639,4.5,4.5,0,0,0,1.589,1.018,4.861,4.861,0,0,0,.852.247l.1.024.108.012.214.023.419.042-.354-.225-.172-.111-.085-.055-.079-.066a4.224,4.224,0,0,1-.579-.539,3.328,3.328,0,0,1-.735-1.25,3.605,3.605,0,0,1-.175-1.329c.011-.113.016-.22.03-.329s.028-.215.056-.321c0-.014.008-.027.011-.042h1.4l-2.781-3.64-2.781,3.64h1.363c.024.1.046.2.075.3",
    transform: "translate(-98.96 -1436.534)",
    fill: "#22c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralProgram);
export default __webpack_public_path__ + "static/media/referral-program.7a4b1bd87dc57f23a4aaa0ef7670d2e1.svg";
export { ForwardRef as ReactComponent };